import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import data from "./data/data.json";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Contact } from "./components/contact";
import Footer from "./components/footer";
import ContactButtons from "./components/ContactButtons";
import JsonData from "./data/data.json";
import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchContact } from "./redux/contactSlice";
import AdminRoute from "./auth/AdminRoute";
import AdminLayout from "./admin/AdminLayout";

// admin pages
import DashboardPage from "./admin/AdminDashboardPage";
import PostsPage from "./admin/AdminPostsPage";
import AdminCategoriesPage from "./admin/AdminCategoriesPage";
import AdminTagsPage from "./admin/AdminTagsPage";
import AdminCommentsPage from "./admin/AdminCommentsPage";
import AdminUsersPage from "./admin/AdminUsersPage";
import AdminSettingsPage from "./admin/AdminSettingsPage";
import PostEditorPage from "./admin/AdminPostEditorPage";
import RoleBasedAdminRedirect from "./auth/RoleBasedAdminRedirect";
import Login from "./components/Login";
import BlogDetail from "./components/blogDetail";
import TestimonialsPage from "./admin/AdminTestimonialsPage";
import TestimonialEditorPage from "./admin/AdminTestimonialsEditorPage";
import ServicesPage from "./admin/AdminServicesPage";
import ServiceEditorPage from "./admin/AdminServicesEditorPage";
import { login } from "./redux/userSlice";
import AdminAppointmentsPage from "./admin/AdminAppointmentsPage";
import AdminCustomersPage from "./admin/AdminCustomersPage";
import AdminCustomerDetailPage from "./admin/AdminCustomerDetailPage";
import AdminSessionsPage from "./admin/AdminSessionsPage";
import AdminExpensesPage from "./admin/AdminExpensesPage";
import AdminPackagesPage from "./admin/AdminPackagesPage";
import AdminMessagesPage from "./admin/AdminMessagesPage";
import { Blog } from "./components/blog";
import EgiticiEgitim from "./components/servicesDetail/egiticiEgitim1";
import OyunTerapisi from "./components/servicesDetail/oyunTerapisi2";
import AileDanismanligi from "./components/servicesDetail/aileDanismanligi";
import DiksiyonEtkili from "./components/servicesDetail/diksiyonEtkili";
import Dir from "./components/servicesDetail/dir-201";
import ScrollToTop from "./components/ScrollToTop";
import CustomerSchedule from "./components/CustomerSchedule";
import AIChatPage from "./components/Aichatpage";
import Packages from "./components/Packages";

const AuthLoader = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchContact());
  }, [dispatch]);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("token");

    if (storedUser && storedToken) {
      try {
        const parsedUser = JSON.parse(storedUser);
        if (parsedUser.id && !parsedUser._id) {
          parsedUser._id = parsedUser.id;
        }
        dispatch(login({ user: parsedUser, token: storedToken }));
      } catch (err) {
        console.error("LocalStorage kullanıcı verisi okunamadı:", err);
      }
    }
  }, [dispatch]);

  return children;
};

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const user = useSelector((state) => state.user.currentUser);

  const dispatch = useDispatch();

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  const StaticLayout = ({ children }) => (
    <div className="App">
      <Navigation />
      <main>{children}</main>
      <ContactButtons />
      <footer id="footer">
        <Footer />
      </footer>
    </div>
  );

  return (
    <AuthLoader>
      <ScrollToTop />
      <Routes>
        {/* Statik Sayfalar */}
        <Route
          path="/"
          element={
            <StaticLayout>
              <Header data={landingPageData.Header} />
              <About data={landingPageData.About} />
              <Services data={data.Services} seo={data.ServicesSEO.seo} />
              <Packages />
              <Gallery data={landingPageData.Gallery} />
              <Testimonials
                data={landingPageData.Testimonials}
                seo={data.TestimonialsSEO.seo}
              />
              <Blog />
              <Contact data={landingPageData.Contact} />
            </StaticLayout>
          }
        />
        <Route
          path="/egitici-egitimi"
          element={
            <StaticLayout>
              <EgiticiEgitim />
            </StaticLayout>
          }
        />
        <Route
          path="/oyun-terapisi"
          element={
            <StaticLayout>
              <OyunTerapisi />
            </StaticLayout>
          }
        />
        <Route path="/asistan" element={<AIChatPage />} />
        <Route
          path="/aile-danismanligi"
          element={
            <StaticLayout>
              <AileDanismanligi />
            </StaticLayout>
          }
        />
        <Route
          path="/diksiyon-ve-etkili-konusma"
          element={
            <StaticLayout>
              <DiksiyonEtkili />
            </StaticLayout>
          }
        />
        <Route
          path="/dirfloortime-201-terapisti"
          element={
            <StaticLayout>
              <Dir />
            </StaticLayout>
          }
        />
        <Route
          path="/blog/:slug"
          element={
            <StaticLayout>
              <BlogDetail />
            </StaticLayout>
          }
        />
        <Route
          path="/login"
          element={
            <StaticLayout>
              <Login />
            </StaticLayout>
          }
        />
        <Route
          path="/ders-programi"
          element={<CustomerSchedule />}
        />

        {/* Admin Paneli */}
        <Route
          path="/admin/*"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index element={<RoleBasedAdminRedirect />} />
          <Route
            path="dashboard"
            element={
              user?.role === "admin" ? (
                <DashboardPage />
              ) : (
                <Navigate to="/admin/posts" replace />
              )
            }
          />
          <Route path="customers" element={<AdminCustomersPage />} />
          <Route path="customers/:customerId/sessions" element={<AdminCustomerDetailPage />} />
          <Route path="sessions" element={<AdminSessionsPage />} />
          <Route path="packages" element={<AdminPackagesPage />} />
          <Route path="expenses" element={<AdminExpensesPage />} />
          <Route path="appointments" element={<AdminAppointmentsPage />} />
          <Route path="messages" element={<AdminMessagesPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="services-editor" element={<ServiceEditorPage />} />
          <Route path="testimonials" element={<TestimonialsPage />} />
          <Route
            path="testimonials/edit/:id"
            element={<TestimonialEditorPage />}
          />
          <Route
            path="testimonials-editor"
            element={<TestimonialEditorPage />}
          />
          <Route path="posts" element={<PostsPage />} />
          <Route path="posts/edit/:id" element={<PostEditorPage />} />
          <Route path="post-editor" element={<PostEditorPage />} />
          <Route
            path="categories"
            element={
              user?.role === "admin" ? (
                <AdminCategoriesPage />
              ) : (
                <Navigate to="/admin/posts" replace />
              )
            }
          />
          <Route
            path="tags"
            element={
              user?.role === "admin" ? (
                <AdminTagsPage />
              ) : (
                <Navigate to="/admin/posts" replace />
              )
            }
          />
          <Route
            path="comments"
            element={
              user?.role === "admin" ? (
                <AdminCommentsPage />
              ) : (
                <Navigate to="/admin/posts" replace />
              )
            }
          />
          <Route
            path="users"
            element={
              user?.role === "admin" ? (
                <AdminUsersPage />
              ) : (
                <Navigate to="/admin/posts" replace />
              )
            }
          />
          <Route
            path="settings"
            element={
              user?.role === "admin" ? (
                <AdminSettingsPage />
              ) : (
                <Navigate to="/admin/posts" replace />
              )
            }
          />
        </Route>

        {/* 404 */}
        <Route
          path="*"
          element={
            <StaticLayout>
              <div className="text-center mt-5">
                <h1>404 - Sayfa bulunamadı</h1>
              </div>
            </StaticLayout>
          }
        />
      </Routes>
    </AuthLoader>
  );
};

export default App;
